import { useEffect, useState } from 'react';

/**
 * A value that settles before it is used.
 *
 * Typing into a search field should not fire a request per keystroke: that is a
 * dozen requests to render one result, and the answers can arrive out of order.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setSettled(value);
    }, delayMs);
    return () => {
      window.clearTimeout(timer);
    };
  }, [value, delayMs]);

  return settled;
}
